// Support IE11
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import smoothscroll from 'smoothscroll-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import 'styles/index.css';
import App from 'App';
import Root from 'Root';
import TagManager from 'react-gtm-module';

// Polyfill window.scrollTo with behaviour: 'smooth' for the browsers
// that don't support it
smoothscroll.polyfill();

// Ensure buttonclick focus behaviour is consistent across browsers
// This fixes programmatic scrolling to fields with errors in some browsers
document.addEventListener('click', (event) => {
  if (event.target.tagName === 'button') {
    event.target.focus();
  }
});

const tagManagerArgs = {
  gtmId: 'GTM-TQ4KRBJ',
};

if (window.PROD_FEATURES === 'true') {
  TagManager.initialize(tagManagerArgs);  
  window.gtag('js', new Date());
  window.gtag('config', window.GA_TAG_NUMBER);
}

if (window.FLOODLIGHT_TRACKING_FEATURES === 'true') {
  window.gtag('js', new Date());
  window.gtag('config', window.FLOODLIGHT_ACCOUNT_NUMBER);
}

ReactDOM.render(
  <Root>
    <App />
  </Root>,
  document.getElementById('app')
);
